/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { CalendarOutlined, CloudUploadOutlined, FileOutlined } from '@ant-design/icons'
import type { PostType } from '@entities/post'
import { MobileHeader } from '@widgets/mobile-header'
import { Space, theme, Typography } from 'antd'
import { useState, type ReactNode } from 'react'

const { Text } = Typography

interface PostingMobileHeaderProps {
    title: string
    current: string
    filter?: ReactNode
    postTypes?: PostType[]
    selectedPostTypes: number[]
    setSelectedPostTypes: React.Dispatch<React.SetStateAction<number[]>>
}

export const PostingMobileHeader = ({
    title,
    current,
    postTypes,
    selectedPostTypes,
    setSelectedPostTypes
}: PostingMobileHeaderProps) => {
    const pages = [
        {
            name: 'draft',
            url: '/posts/draft',
            title: (
                <Space>
                    <FileOutlined style={{ fontSize: '17px' }} />
                    <Text style={{ fontSize: '17px', fontWeight: 500 }}>Черновики</Text>
                </Space>
            )
        },
        {
            name: 'scheduled',
            url: '/posts/scheduled',
            title: (
                <Space>
                    <CalendarOutlined style={{ fontSize: '17px' }} />
                    <Text style={{ fontSize: '17px', fontWeight: 500 }}>Запланированные</Text>
                </Space>
            )
        },
        {
            name: 'published',
            url: '/posts/published',
            title: (
                <Space>
                    <CloudUploadOutlined style={{ fontSize: '17px' }} />
                    <Text style={{ fontSize: '17px', fontWeight: 500 }}>Опубликованные</Text>
                </Space>
            )
        }
    ]

    const {
        token: { colorPrimary }
    } = theme.useToken()

    const [filterOpened, setFilterOpened] = useState(false)

    return (
        <MobileHeader
            pages={pages}
            title={title}
            current={current}
            // filter={
            //     <Dropdown>
            //         <Dropdown.Item
            //             arrowIcon={null}
            //             title={
            //                 <Flex align="center">
            //                     <div
            //                         className={styles.filterBtn}
            //                         onClick={() => {
            //                             setFilterOpened((prev) => !prev)
            //                         }}
            //                     >
            //                         <Space size={0}>
            //                             <FilterOutlined />
            //                             {filterOpened ? (
            //                                 <ChevronDown size={14} style={{ verticalAlign: 'middle' }} />
            //                             ) : (
            //                                 <ChevronUp size={14} style={{ verticalAlign: 'middle' }} />
            //                             )}
            //                         </Space>
            //                     </div>
            //                 </Flex>
            //             }
            //             key="posting-page"
            //         >
            //             {postTypes?.map((t) => (
            //                 <div
            //                     key={t.id}
            //                     style={{ padding: '10px' }}
            //                     className={styles.filterOption}
            //                     onClick={() =>
            //                         setSelectedPostTypes((prev) => {
            //                             if (prev.includes(t.id!)) {
            //                                 return prev.filter((id) => id !== t.id)
            //                             } else {
            //                                 return [...prev, t.id!]
            //                             }
            //                         })
            //                     }
            //                 >
            //                     <Flex justify="space-between" align="center">
            //                         <CustomTag color={t.color}>{t.name}</CustomTag>
            //                         {selectedPostTypes.find((pt) => pt === t.id) && <Check color={colorPrimary} />}
            //                     </Flex>
            //                 </div>
            //             ))}
            //         </Dropdown.Item>
            //     </Dropdown>
            // }
            dropdownKey="posting-page"
        />
    )
}
